import React from 'react';
import clx from 'classnames';
import { Channel } from 'client/model/skill';

import styles from './ScreenshotBlock.module.scss';

interface ScreenshotBlockProps {
    channel: Channel;
    screenshotUrl?: string;
}

export const ScreenshotBlock = ({ channel, screenshotUrl }: ScreenshotBlockProps) => {
    if (!screenshotUrl) return null;
    if (channel === Channel.TvApp)
        return (
            <div className={clx(styles.screenshotBlock__container, styles.screenshotBlock__container_tv)}>
                <div className={styles.ScreenshotBlock__shadow}></div>
                <div
                    className={clx(styles.screenshotBlock__image, styles.screenshotBlock__image_tv)}
                    style={{ backgroundImage: `url(${screenshotUrl})` }}
                ></div>
                <img
                    className={clx(styles.screenshotBlock__border, styles.screenshotBlock__border_tv)}
                    src={
                        'https://avatars.mds.yandex.net/get-dialogs/1644703/screenshot-tv-empty-border/catalogue-banner-x1'
                    }
                    alt="empty-tv-border"
                />
            </div>
        );
    if (channel === Channel.SmartScreenApp)
        return (
            <div className={clx(styles.screenshotBlock__container, styles.screenshotBlock__container_smartScreen)}>
                <div className={styles.ScreenshotBlock__shadow}></div>
                <div
                    className={clx(styles.screenshotBlock__image, styles.screenshotBlock__image_smartScreen)}
                    style={{ backgroundImage: `url(${screenshotUrl})` }}
                ></div>
                <img
                    className={clx(styles.screenshotBlock__border, styles.screenshotBlock__border_smartScreen)}
                    src={
                        'https://avatars.mds.yandex.net/get-dialogs/399212/screenshot-device-with-screen-empty-border/catalogue-banner-x1'
                    }
                    alt="empty-smartScreen-border"
                />
            </div>
        );
    return null;
};
